export default __webpack_public_path__ + "static/media/music.8b3a7c09.jpg";